import { OPCOES_FILTRO_DATA } from '@constants/Text'
import {
  FIELD_KEY_TO_GETTER,
  WALLET_STANDALONE_FILTER_KEYS,
  resolveWalletFilterFields,
} from '@modules/consolidator/utils/normalize-wallet-filters/normalize-wallet-filters'

const WALLET_ALL_SENTINELS = new Set(['Consolidado', 'Todos', 'Todas'])

const ALWAYS_ACTIVE_KEYS = new Set(['modoFiltroCorretora', 'filtroData'])

const DEFAULT_WALLET_FIELDS = [
  { key: 'modoFiltroCorretora' },
  { key: 'filtroCorretora' },
  { key: 'investmentTypeFilter' },
  { key: 'filtroData', items: Object.values(OPCOES_FILTRO_DATA) },
]

const fieldKey = (field) => (typeof field === 'string' ? field : field.key)

export const isWalletFilterActive = (value, field) => {
  if (Array.isArray(value)) return value.length > 0
  if (value === null || value === undefined || value === '') return false
  if (ALWAYS_ACTIVE_KEYS.has(field.key)) return true
  return !WALLET_ALL_SENTINELS.has(value)
}

export const buildWalletCombinedFields = ({
  fields,
  dynamicFields,
  enabledFieldKeys,
  groupedModo,
}) => {
  const baseFields = Array.isArray(fields) ? fields : DEFAULT_WALLET_FIELDS
  const newFields = Array.isArray(dynamicFields) ? dynamicFields : []
  const anchorKeys = new Set(['investmentTypeFilter', 'filtroData'])
  const anchorIndex = baseFields.findIndex((field) =>
    anchorKeys.has(fieldKey(field))
  )
  const merged =
    anchorIndex === -1
      ? [...baseFields, ...newFields]
      : [
          ...baseFields.slice(0, anchorIndex),
          ...newFields,
          ...baseFields.slice(anchorIndex),
        ]
  const visible = merged.filter((field) => {
    const key = fieldKey(field)
    return !(WALLET_STANDALONE_FILTER_KEYS.includes(key) && key === groupedModo)
  })
  if (!Array.isArray(enabledFieldKeys)) return visible
  const allowed = new Set(enabledFieldKeys)
  return visible.filter((field) => allowed.has(fieldKey(field)))
}

export const resolveWalletActiveCount = ({ store, fields, enabledFieldKeys }) => {
  const dynamicFields =
    store.getters['consolidator/walletAnalysisOptionsFields'] || []
  const groupedModo = store.getters['consolidator/walletFiltersModo']
  const combined = buildWalletCombinedFields({
    fields,
    dynamicFields,
    enabledFieldKeys,
    groupedModo,
  })
  const resolved = resolveWalletFilterFields({ fields: combined, store })
  let count = 0
  for (const field of resolved) {
    const getter = FIELD_KEY_TO_GETTER[field.key]
    const value = getter ? store.getters[getter] : ''
    if (isWalletFilterActive(value, field)) count++
  }
  return count
}
